import { render } from "./cross-icon.vue.js?vue&type=template&id=c15bd6cc!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./cross-icon.vue?vue&type=template&id=c15bd6cc"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__